// Campos do laudo de calibracao de PRESSOSTATO.
// Para mudar esse formulario, mexa so neste arquivo.
const pressostato = {
  titulo: 'Pressostato',
  leituras: 'pressostato',
  secoes: [
    {
      titulo: 'Identificação do instrumento',
      campos: [
        { n: 'tag', l: 'TAG', t: 'texto', span: 4, up: true, ajuda: 'Identificação do pressostato dentro do cliente. Ex.: PRE-01.' },
        { n: 'marca', l: 'Marca', t: 'texto', span: 5, ajuda: 'Fabricante gravado no instrumento. Em branco sai NÃO CONSTA no laudo.' },
        { n: 'numero_serie', l: 'Nº de série', t: 'texto', span: 5, ajuda: 'Número de série do pressostato. Em branco sai NÃO CONSTA.' },
        { n: 'lacre', l: 'Lacre', t: 'texto', span: 5, ajuda: 'Identificação do lacre aplicado após o ajuste. Ex.: BLINDADO.' },
        { n: 'conexao', l: 'Conexão', t: 'sel', span: 5, ajuda: 'Bitola da rosca de ligação.',
          o: [['1/4', '1/4"'], ['1/2', '1/2"'], ['3/4', '3/4"'], ['outra', 'Outra']] },
        { n: 'local_instalacao', l: 'Local de instalação', t: 'texto', span: 6, up: true, ajuda: 'Equipamento onde o pressostato está instalado. Normalmente a TAG do vaso ou da caldeira. É essa pasta que recebe o PDF no portal.' },
        { n: 'fluido_trabalho', l: 'Fluido de trabalho', t: 'texto', span: 5, ajuda: 'Fluido do processo em que o pressostato atua. Ex.: ar, vapor.' },
        { n: 'unidade', l: 'Unidade', t: 'sel', span: 4, ajuda: 'Unidade de pressão de todas as leituras.',
          o: [['kgf', 'kgf/cm²'], ['bar', 'bar'], ['psi', 'psi'], ['mpa', 'MPa']] },
        { n: 'validade_anos', l: 'Validade', t: 'sel', span: 3, ajuda: 'De quanto em quanto tempo o pressostato deve ser recalibrado.',
          o: [[1, '1 ano'], [2, '2 anos'], [3, '3 anos'], [4, '4 anos'], [5, '5 anos']] },
        { n: 'data_calibracao', l: 'Data', t: 'data', span: 3, ajuda: 'Data em que a calibração foi executada.' }
      ]
    },
    {
      titulo: 'Ajuste e condições',
      campos: [
        { n: 'pressao_liga', l: 'Liga', t: 'num', span: 4, ajuda: 'Pressão em que o pressostato rearma, ou seja, volta a ligar.' },
        { n: 'pressao_desliga', l: 'Desliga', t: 'num', span: 4, ajuda: 'Pressão em que o pressostato atua e desliga. É o ponto de ajuste.' },
        { n: '_diferencial', l: 'Diferencial', t: 'calc', span: 4, ajuda: 'Desliga menos Liga. Calculado sozinho, não é digitado.',
          calc: (v) => (v.pressao_liga != null && v.pressao_desliga != null)
            ? String(Number(v.pressao_desliga) - Number(v.pressao_liga)).replace('.', ',') : '' },
        { n: '_histerese', l: 'Histerese', t: 'calc', span: 4, ajuda: 'Diferencial dividido pelo Desliga, em percentual. Calculada sozinha.',
          calc: (v) => (v.pressao_liga != null && v.pressao_desliga != null && Number(v.pressao_desliga) !== 0)
            ? ((Number(v.pressao_desliga) - Number(v.pressao_liga)) / Number(v.pressao_desliga) * 100).toFixed(2).replace('.', ',') + ' %' : '' },
        { n: 'temp_ambiente', l: 'Temperatura ambiente', t: 'texto', span: 4, ajuda: 'Temperatura do ambiente durante a calibração, com a tolerância.' },
        { n: 'umidade', l: 'Umidade do ar', t: 'texto', span: 4, ajuda: 'Umidade do ambiente durante a calibração, com a tolerância.' }
      ]
    }
  ],
  pontos: {
    ajuda: 'Cada linha é uma repetição do ensaio: o valor de referência do ponto e as pressões em que o pressostato abriu e fechou. Pode repetir o mesmo V.I quantas vezes precisar.',
    colunas: [
      { n: 'vi', l: 'V.I — valor de referência', ajuda: 'Pressão de referência do ponto, lida no manômetro padrão.' },
      { n: 'abertura', l: 'Abertura', ajuda: 'Pressão em que o contato abriu nessa repetição.' },
      { n: 'fechamento', l: 'Fechamento', ajuda: 'Pressão em que o contato fechou nessa repetição.' }
    ]
  },
  fechamento: [
    { n: 'fator_k', l: 'Fator k', t: 'sel', span: 4, o: [[2, '2 (95%)'], [3, '3 (99%)']],
      ajuda: 'Multiplicador da incerteza padrão para chegar na incerteza expandida. k = 2 corresponde a cerca de 95% de confiança.' },
    { n: 'danificado', l: 'Danificado?', t: 'bool', span: 4, ajuda: 'Marque se o pressostato chegou com dano que impeça o uso.' },
    { n: 'substituido', l: 'Substituído?', t: 'bool', span: 4, ajuda: 'Marque se o pressostato foi trocado por outro no atendimento.' }
  ]
};

export default pressostato;
